import React, { useEffect, useState } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import './aboutoverview.css';



const Aboutoverview = () => {
    // Skewed text
    const [sktexth1, setSktexth1] = useState("");
    const [sktexth2, setSktexth2] = useState("");
    const [sktext0, setSktext0] = useState("");
    const [sktext1, setSktext1] = useState("");
    const [sktext2, setSktext2] = useState("");
    const [sktext3, setSktext3] = useState("");
    const [sktext4, setSktext4] = useState("");
    useEffect(() => {

        let sktexth1 = "Who we are";
        let arrh1 = sktexth1.split(' ');
        let resulth1 = '<span class="rotate"> ' +
            arrh1.join(' </span><span class="rotate">') +
            '</span>';
        setSktexth1(resulth1);

        let sktexth2 = "How we serve";
        let arrh2 = sktexth2.split(' ');
        let resulth2 = '<span class="rotate"> ' +
            arrh2.join(' </span><span class="rotate">') +
            '</span>';
        setSktexth2(resulth2);
        
        let sktext0 = "Our roots go back to 2018.";
        let arr0 = sktext0.split(' ');
        let result0 = '<span class="rotate"> ' +
            arr0.join(' </span><span class="rotate">') +
            '</span>';
        setSktext0(result0);

    
        // let sktext1 = "We are an India-based fast growing offshore consulting firm, with a focus on corporate and investment advisory. We've built our knowledge base after years of advising the in-house team of family offices, fund managers and corporates. ";
        let sktext1 = "We are an India-based fast growing offshore consulting firm, with a focus on corporate and investment advisory. We've built our knowledge base after years of advising the in-house team of family offices, fund managers and corporates.";
        let arr1 = sktext1.split(' ');
        let result1 = '<span class="rotate"> ' +
            arr1.join(' </span><span class="rotate">') +
            '</span>';
        setSktext1(result1);
        
        let sktext2 = "We approach all our engagements with a unified vision of enabling our clients to make informed decisions that unlock value and sustained growth by simplifying and quantifying results for them.";
        let arr2 = sktext2.split(' ');
        let result2 = '<span class="rotate"> ' +
            arr2.join(' </span><span class="rotate">') +
            '</span>';
        setSktext2(result2);

        
        // let sktext3 = "Our consultants function as an extension of your team to provide crucial support on all aspects of business & investment strategy and analytics, measurement & reporting. To ensure that we offer the highest standard of excellence, we've carefully created a culture of learning and value creation. We've built a team of seasoned financial, strategy and data professionals who are passionate about problem-solving. ";
        let sktext3 = "Our consultants function as an extension of your team to provide crucial support on all aspects of business & investment strategy and analytics, measurement & reporting. To ensure that we offer the highest standard of excellence, we've carefully created a culture of learning and value creation. We've built a c.250 members team of seasoned financial, strategy and data professionals who are passionate about problem-solving.";
        let arr3 = sktext3.split(' ');
        let result3 = '<span class="rotate"> ' +
            arr3.join(' </span><span class="rotate">') +
            '</span>';
        setSktext3(result3);

        let sktext4 = "We are ISO and SOC 2 compliant, ensuring our clients' information is managed with integrity and confidentiality.";
        let arr4 = sktext4.split(' ');
        let result4 = '<span class="rotate"> ' +
            arr4.join(' </span><span class="rotate">') +
            '</span>';
        setSktext4(result4);


    }, [sktext1]);



    const count = '8 years';
    const counttext1 = 'Celebrating '

    const counttext2 = 'Of Learning'
    return (
        <>

            {/* <div className='arrowbg'></div> */}

            <section className='overview-section desktop' >
                {/* <div className='overviewbg'></div> */}
                <Container fluid>
                    <Row className=' '>

                        <Col lg={4} xl={4} xxl={4} className='col-md-3 offset-2'>

                            <div className='counter'>
                                <h4 className='counttext' >
                                    {counttext1}
                                </h4>
                                <h2 className='count'  >
                                    {count}

                                </h2>
                                <h4 className='counttext2' >
                                    {counttext2}
                                </h4>
                            </div>

                        </Col>

                        <Col lg={5} xl={5} xxl={5} className='col-md-9 '>
                            <div className='content-box'>
                                {/* <h2>Who</h2> */}
                                <div className='relative'>
                                    <div className="strok">Overview</div>
                                    <div className="h1 anima"> <span className='anima-underline'>Over</span>
                                        view</div>
                                </div>

                                <div className=''>
                                    <h4 className='head1 holder' dangerouslySetInnerHTML={{ __html: sktexth1 }}></h4>
                                    <p className='p0 holder' dangerouslySetInnerHTML={{ __html: sktext0 }}></p>
                                    <p className='p1 holder' dangerouslySetInnerHTML={{ __html: sktext1 }}></p>
                                    <h4 className='head2 holder' dangerouslySetInnerHTML={{ __html: sktexth2 }}></h4>
                                    <p className='p2 holder' dangerouslySetInnerHTML={{ __html: sktext2 }}></p>
                                    <p className='p3 holder' dangerouslySetInnerHTML={{ __html: sktext3 }}></p>
                                    <p className='p4 holder' dangerouslySetInnerHTML={{ __html: sktext4 }}></p>
                                </div>
                                {/* <p >We are an India-based, boutique offshore management consulting firm, with a focus on corporate and investment advisory. We've built our expertise in the LP, GP ecosystem after years of working in similar trenches as the in-house team of family offices, fund managers and corporates.<br />
                                    <span className='mt-3 rotate'>We approach all our engagements with a unified vision of enabling our clients to make informed decisions that unlock value and sustained growth by simplifying and quantifyingesults for them.</span><br />
                                    <span className='mt-3 rotate'>Our consultants function as an extension of your team to provide crucial support on all aspects of business & investment strategy and analytics, measurement & reporting. To ensure that we offer the highest standard of excellence,we've carefully created a culture of learning and value creation. We've built a team of seasoned financial and strategy professionals who are passionate about problem-solving. Our experts have specialized exposure in diverse industries ranging from real estate (including residential, commercial, hospitality, retail, and tourism),aviation, energy, financial services, and technology."</span></p> */}
                                {/* <button className="findout-btn mt-2 ">Find out more about us</button> */}
                            </div>



                        </Col>


                    </Row>
                </Container>

            </section>

            <section className='overview-section mobile' >
                <Container fluid>
                    <div className='content-box'>
                        <div className="strok">Overview</div>
                        <div className="h1 anima">Ove<span className='anima-underline'>rvie</span>w</div>
                    </div>
                </Container>
                <Container fluid className='mt-5 overview-bg'>
                    <Row>
                    <div className='counter'>
                                <h4 className='counttext' >
                                    {counttext1}
                                </h4>
                                <h2 className='count'  >
                                    {count}

                                </h2>
                                <h4 className='counttext2' >
                                    {counttext2}
                                </h4>
                            </div>
                    </Row>
                </Container>
                <Container>
                    <Row>
                        <div className='paragraph-div mt-5'>
                            <h5  dangerouslySetInnerHTML={{ __html: sktexth1 }}></h5>
                            <p  dangerouslySetInnerHTML={{ __html: sktext0 }}></p>
                            <p  dangerouslySetInnerHTML={{ __html: sktext1 }}></p>
                            <h5  dangerouslySetInnerHTML={{ __html: sktexth2 }}></h5>
                            <p  dangerouslySetInnerHTML={{ __html: sktext2 }}></p>
                            <p  dangerouslySetInnerHTML={{ __html: sktext3 }}></p>
                            <p  dangerouslySetInnerHTML={{ __html: sktext4 }}></p>
                        </div>
                    </Row>
                </Container>

            </section>

            <section className='overview-section tab' >
                <Container fluid className=' overview-bg'>
                    <Row>
                    <div className='counter'>
                                <h4 className='counttext' >
                                    {counttext1}
                                </h4>
                                <h2 className='count'  >
                                    {count}

                                </h2>
                                <h4 className='counttext2' >
                                    {counttext2}
                                </h4>
                            </div>
                    </Row>
                </Container>
                {/* <Container fluid>
                    <div className='content-box'>
                        <div className="strok">Overview</div>
                        <div className="h1 anima">Ove<span className='anima-underline'>rvie</span>w</div>
                    </div>
                </Container> */}
 
                <Container >
                    <Row>
                        <div className='col-md-4'>
                            <div className='content-box'>
                                <div className='relative'>
                                    <div className="strok">Overview</div>
                                    <div className="h1 anima"><span className='anima-underline'>Over</span>view</div>
                                </div>
                            </div>

                        </div>            

                        <div className='col-md-8'>
                            <div className='paragraph-div mt-5'>
                                <h5  dangerouslySetInnerHTML={{ __html: sktexth1 }}></h5>
                                <p  dangerouslySetInnerHTML={{ __html: sktext0 }}></p>
                                <p  dangerouslySetInnerHTML={{ __html: sktext1 }}></p>
                                <h5  dangerouslySetInnerHTML={{ __html: sktexth2 }}></h5>
                                <p  dangerouslySetInnerHTML={{ __html: sktext2 }}></p>
                                <p  dangerouslySetInnerHTML={{ __html: sktext3 }}></p>
                                <p  dangerouslySetInnerHTML={{ __html: sktext4 }}></p>
                            </div>
                        </div>            

                    </Row>
                </Container>

            </section>

        </>
    )
}

export default Aboutoverview